<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <b-img
            fluid
            :src="geolimLogo"
            alt="Logo"
height="40px"
    width="40px"
          />
        <h2 class="brand-text text-primary ml-1">
          PT GEOSERVICES
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            class="mb-1 font-weight-bold"
            title-tag="h2"
          >
            Welcome to Geolim.! 👋
          </b-card-title>
          <b-card-text class="mb-2">
            Please sign-in to your account and start the adventure
          </b-card-text>

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <!-- email -->
              <b-form-group
                label="Email"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    autocomplete="false"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      autocomplete="false"
                      placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                Sign in
              </b-button><br>
<a
href="javascript:void(0);"
@click="goToCertificateValidator"
>Click Here</a> To Check Notary Validity

<p><a
href="javascript:void(0);"
@click="goToForgotPassword"
>Click Here</a> To Forgot Password</p>
            </b-form>
          </validation-observer>

        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, VBTooltip,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: '',
      password: '',
      status: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      geolimLogo: require('@/assets/images/logo/geolim.png'),
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  mounted() {
    if (this.$route.query.sessionExpired) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: 'Sesi Berakhir',
          icon: 'AlertTriangleIcon',
          variant: 'warning',
          text: 'Your session has expired or your access has been revoked. Please sign in again.',
        },
      })
    }
  },
  methods: {
    goToCertificateValidator() {
      this.$router.push({ name: 'certificate-validator' }).catch(error => {
  if (
    error.name !== 'NavigationDuplicated' && !error.message.includes('Avoided redundant navigation to current location')
  ) {
    console.log(error)
  }
})
  },
    goToForgotPassword() {
      this.$router.push({ name: 'forgot-password' }).catch(error => {
  if (
    error.name !== 'NavigationDuplicated' && !error.message.includes('Avoided redundant navigation to current location')
  ) {
    console.log(error)
  }
})
  },
    login() {
      this.$refs.loginForm.validate().then(success => {
        const payload = {
            Email: this.userEmail,
            Password: this.password,
          }
          const headers = {
        'Content-Type': 'application/json',
    }
        if (success) {
          axios
        .post(process.env.VUE_APP_API_LOGIN_URL, payload, { headers })
        .then(response => {
          console.log(response)
              const { Payload } = response.data
              console.log(Payload)
              const userData = Payload.UserData
              console.log('Token', Payload.Token)
              localStorage.setItem('userToken', Payload.Token)
              console.log('KodeUnitKerja',userData.KodeUnitKerja)
              this.$cookies.set('KodeUnitKerja', userData.KodeUnitKerja)
              this.$cookies.set('UserRole', userData.UserRoleSystem)
              localStorage.setItem('userData', JSON.stringify(userData))
              this.$router.replace({ name: 'dashboard-ecommerce' })
                .then(() => {
                  const firstName = userData.FullName.charAt(0).toUpperCase() + userData.FullName.slice(1)
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: `Welcome ${firstName}`,
                      icon: 'CoffeeIcon',
                      variant: 'success',
                      text: `You have successfully logged in as ${userData.UserRoleName}. Now you can start to explore!`,
                    },
                  })
                })
            }).catch(error => {
              console.log(error)
              const backendMessage = error.response && error.response.data && error.response.data.Message
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'Notification',
                      icon: 'BellIcon',
                      variant: 'danger',
                      text: backendMessage || 'Wrong Email / Password',
                    },
                  })
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
